// @flow
import { Set } from 'immutable';

function cleanTagValue(
  selected: string[],
  choices: string[]
): { selected: string[], userAdded: string[] } {
  const choiceSet = new Set(choices);
  const selectedChoices = [];
  const userAdded = [];

  selected.forEach(selectedChoice => {
    const isUserAdded = !choiceSet.has(selectedChoice);

    if (isUserAdded) {
      userAdded.push(selectedChoice);
    } else {
      selectedChoices.push(selectedChoice);
    }
  });

  return { selected: selectedChoices, userAdded };
}

export default class ClientSpecificQuestion {
  +label: string;
  +selected: string[];
  +userAdded: string[];
  +hidden: boolean;

  constructor(
    label: string,
    selected: string[],
    userAdded: string[],
    hidden: boolean
  ) {
    (this: any).label = label;
    (this: any).selected = selected;
    (this: any).userAdded = userAdded;
    (this: any).hidden = hidden;
  }

  static create(csqObject: ClientSpecificQuestionBlob): ClientSpecificQuestion {
    const {
      type,
      id: _id,
      label: _label,
      value,
      do_not_display: hidden = false,
    } = csqObject;
    const label = _label || _id;
    let selected = [];
    let userAdded = [];

    if (type === 'sub_rating' && typeof value === 'number') {
      selected.push(String(value));
    } else if (type === 'text' && Array.isArray(value)) {
      selected.push(...value);
    } else if (type === 'text' && typeof value === 'string') {
      selected.push(value);
    } else if (
      type === 'tag' &&
      (!Array.isArray(value) && typeof value === 'object')
    ) {
      const cleanedValue = cleanTagValue(value.selected, value.choices);
      selected = cleanedValue.selected;
      userAdded = cleanedValue.userAdded;
    }

    return new ClientSpecificQuestion(label, selected, userAdded, hidden);
  }
}



// WEBPACK FOOTER //
// ./src/models/ClientSpecificQuestion.js